import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate, removeReCaptchaBadge, blueimpGalleryDestroy } from './shared/common'
import { buildOwl, destroyOwl } from './shared/owlcarousel'
// controllers
import Controller from './controllers/Controller'
import MagicGridController from './controllers/MagicGridController'
import DatePickerController from './controllers/DatePickerController'
import MapsController from './controllers/MapsController'
// views
import BasicView from './views/BasicView'
import ListView from './views/ListView'


const routes = {
  'basic': {
    controller: Controller,
    view: BasicView
  },
  'list': {
    controller: Controller,
    view: ListView
  },
  'magic_grid': {
    controller: MagicGridController,
    view: ListView
  },
  'date_picker': {
    controller: DatePickerController,
    view: null
  },
  'map': {
    controller: MapsController,
    view: null
  },
}

const aswapProps = {
  animationTimeHide: 600,
  animationTimeShow: 600,
  preloadOnHover: false,
  cacheOn: true,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    // WCAG.onViewChanged() // removed to make no-as-scroll work!
    blueimpGalleryDestroy()
    windowUpdate()
    buildOwl()
    RytmWebflow.showUp.rebuild()
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    RytmWebflow.showUp.hide()
    RytmWebflow.bootsrap5.hideFlyovers()
  },
  onViewHidden: () => {
    destroyOwl()
  }
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}